<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-XiaoXiWeiXuanZhong`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.73489 16.9945C3.47051 16.5457 3.29733 16.2447 3.21125 16.084C2.41377 14.5968 1.9976 12.9349 2.00001 11.2473C2.00001 5.58798 6.58802 1 12.2474 1C17.9068 1 22.4948 5.58798 22.4948 11.2473C22.4948 16.9067 17.9068 21.4946 12.2474 21.4946C10.3937 21.4974 8.57428 20.995 6.9846 20.0416C6.82445 19.9467 6.66391 19.8525 6.50297 19.759L3.99543 20.443C3.42158 20.5993 2.89538 20.0728 3.05191 19.4992L3.73489 16.9945Z" stroke="#929293" stroke-width="2"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.22765 13.6738C9.53781 13.3992 10.0118 13.4281 10.2863 13.7383C10.6285 14.1248 11.4137 14.5322 12.3922 14.6221C13.3429 14.7095 14.3672 14.4855 15.1959 13.7632C15.5082 13.4911 15.9819 13.5236 16.2541 13.8359C16.5263 14.1481 16.4937 14.6219 16.1815 14.894C14.9851 15.9367 13.5292 16.2329 12.255 16.1158C11.0087 16.0013 9.82445 15.4796 9.16314 14.7325C8.8886 14.4223 8.91748 13.9483 9.22765 13.6738Z" :fill="useCurrentColor ? 'currentColor' : '#929293'"/></svg>
</template>
<script>

export default {
  name: 'IconXiaoXiWeiXuanZhong',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
